import InfiniteScroll from './useInfiniteScroll';

export default InfiniteScroll;
